import React from "react";
import { Box, Typography } from "@mui/material";
import CouponSection from "../CouponAvalibleSection/component";
import CouponRewardCard from "../CouponReward/component";
import { useNavigate } from "react-router-dom";
import MoreCardsSection from "../DigittalProductSuggestion/DigittalProductSuggestion";
const CartList = ({ RemoveCoupon,cartList, increaseQuantity, decreaseQuantity,
  fetchCouponsList ,setShowCoupoListFlag,fullObjectRewardCart,removebtnflag ,ConformRemoveCoupon}) => {
    //console.log("fullObjectRewardCart",fullObjectRewardCart)
    const navigate=useNavigate();
  const TruncatedVmname = ({ text = "", limit = 25 }) => (
    <span style={{ fontSize: "14px", color: "#384F6F" }}>
      {text.length <= limit ? text : `${text.substring(0, limit)}...`}
    </span>
  );

  const handleItems=()=>{
    navigate(`/items?machineId=${localStorage.getItem("machineId")}&showItems=true`)
  }
  return (
    <>

    <div style={{padding:"15px",paddingTop:"80px",    paddingBottom: "170px"}}>
          <Box display={"flex"} justifyContent={"space-between"}>
   <Typography
  style={{
    color: "rgba(113, 129, 152, 1)",
    fontSize: "17px",
    fontWeight: "500",
    padding: "10px",
  }}
>
 
 {cartList[0]&&cartList.reduce((total, item) => total + item.count, 0)} Item{cartList.length > 1 ? "s" : ""} In Your Cart
</Typography>

           <Typography
        style={{
          color: "rgb(0,177,119)",
          fontSize: "17px",
          fontWeight: "500",
        padding:"10px"
        }}
          onClick={(e)=>{handleItems(e)}}
      >
+ add item
      </Typography>
</Box>
      {cartList.map((el, index) => (
        <Box
          key={index}
          mb={3}
          p={2}
          display="flex"
          alignItems="center"
          borderRadius="16px"
          boxShadow="0px 4px 10px rgba(56, 79, 111, 0.12)"
          sx={{ backgroundColor: "white" }}
        >
          {/* Product Image */}
          <Box
            sx={{
              height: 78,
              width: 77,
              borderRadius: "8px",
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mr: 2,
              backgroundColor: "#f5f5f5",
            }}
          >
            {el.variantImages?.[0] ? (
              <img
                src={`https://daalchini.s3.ap-south-1.amazonaws.com/dcprod/${el.variantImages[0]}`}
                alt={el.mvName}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                loading="lazy"
              />
            ) : (
              <Typography variant="caption" color="text.secondary">
                No Image
              </Typography>
            )}
          </Box>

          {/* Product Details */}
          <Box flex={1}>
            <Typography variant="subtitle1" fontWeight={600}>
              <TruncatedVmname text={el.mvName} limit={25} />
            </Typography>

            <Typography variant="body2" color="text.secondary">
              Tray: {el.slotId ? el.slotId.toString()[0] : "-"}
            </Typography>

            {/* Price and Quantity Controls */}
            <Box
              mt={1}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              {/* Price Section */}
              <Box display="flex" alignItems="center" gap={1}>
                {el.discountedAmount ? (
                  <>
                    <Typography
                      variant="body2"
                      sx={{
                        textDecoration: "line-through",
                        color: "gray",
                        fontSize: "15px",
                      }}
                    >
                      ₹ {el.amount.toFixed(2)}
                    </Typography>
                    <Typography
                      variant="body1"
                      fontWeight={600}
                      sx={{ fontSize: "3vw" }}
                    >
                      ₹ {el.discountedAmount.toFixed(2)}
                    </Typography>
                  </>
                ) : (
                  <Typography
                    variant="body1"
                    fontWeight={600}
                    sx={{ fontSize: "3vw" }}
                  >
                    ₹ {el.amount.toFixed(2)}
                  </Typography>
                )}
              </Box>

              {/* Quantity Controls */}
              {el.count > 0 ? (
                <Box
                style={{backgroundColor:"#00B177"}}
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  width={100}
                  px={1}
                  py={0.5}
                  border="1px solid #00B177"
                  borderRadius="8px"
                  bgcolor="rgba(0, 177, 119, 0.04)"
                 
                >
                  <Typography
                    onClick={(e) => decreaseQuantity(e, index, el.slotId, el.count)}
                    sx={{
                      cursor: "pointer",
                      color: "#ffffff",
                      userSelect: "none",
                    }}
                  >
                    -
                  </Typography>
                  <Typography fontSize="14px" fontWeight={500} color={"white"}>
                    {el.count}
                  </Typography>
                  <Typography
                    onClick={(e) => increaseQuantity(e, index, el.slotId, el.count,"add")}
                    sx={{
                      cursor: "pointer",
                      color: "#ffffff",
                      userSelect: "none",
                    }}
                  >
                    +
                  </Typography>
                </Box>
              ) : (
                <Box
                  onClick={(e) => increaseQuantity(e, index, el.slot_id, el.count,"add")}
                  width={100}
                  textAlign="center"
                  py={0.7}
                  border="1px solid #00B177"
                  borderRadius="8px"
                  color="#00B177"
                  fontWeight={600}
                  sx={{
                    cursor: "pointer",
                    bgcolor: "rgba(0, 177, 119, 0.04)",
                    userSelect: "none",
                  }}
                >
                  ADD
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      ))}
      <CouponSection fullObjectRewardCart={fullObjectRewardCart} removebtnflag={removebtnflag} fetchCouponsList={fetchCouponsList} setShowCoupoListFlag={setShowCoupoListFlag} ConformRemoveCoupon={ConformRemoveCoupon} RemoveCoupon={RemoveCoupon} />



  {/*     <MoreCardsSection/> */}
            <CouponRewardCard fullObjectRewardCart={fullObjectRewardCart} />
      </div>
    </>
  );
};

export default CartList;
